"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _text = require("../../../helpers/text");
var _tokens = require("../../../tokens");
var _Wrapper = _interopRequireDefault(require("../../Wrapper"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const StyledP = (0, _styledComponents.default)(props => {
  return /*#__PURE__*/_react.default.createElement(_Wrapper.default, _extends({
    omitProps: {
      keys: ['size', 'strong', 'color']
    },
    tag: "p",
    bumpSpecificity: true
  }, props));
}).withConfig({
  displayName: "StyledP",
  componentId: "sc-xz5naf-0"
})(["", " ", " ", ""], _ref => {
  let {
    size
  } = _ref;
  switch (size) {
    case 'S':
      return _text.paragraphS;
    case 'L':
      return _text.paragraphL;
    default:
      return _text.paragraphM;
  }
}, _ref2 => {
  let {
    strong
  } = _ref2;
  return strong && `
    color: ${_tokens.COLOR.BLACK};
    font-weight: ${_tokens.FONT.WEIGHT.MEDIUM};
  `;
}, _ref3 => {
  let {
    color
  } = _ref3;
  return color && `color: ${color};`;
});

/**
## Usage

```jsx
import { P } from '@farewill/ui'
```

## Notes

`<P>`s extend `<Wrapper>` so can use any of `<Wrapper>`’s styling functionality, notably the `margin` and `centered` properties.

### Typography use

Visuelt is our main typeface, used across both the product and marketing pages. It is clean, legible and functional.

The default paragraph font size is 18px on large screens and 16px on small screens. You can also use `Body L` to create a lead paragraph. Use `Body S` for things like disclaimers or extra information.

*/
const P = _ref4 => {
  let {
    children,
    ...props
  } = _ref4;
  return /*#__PURE__*/_react.default.createElement(StyledP, props, children);
};
var _default = exports.default = P;